import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
// Add your imports here
import Login from "pages/login";
import SelectHotel from "pages/select-hotel";
import Dashboard from "pages/dashboard";
import FinancialManagement from "pages/financial-management";
import Reservations from "pages/reservations";
import RoomManagement from "pages/room-management";
import ReportsAndAnalytics from "pages/reports-and-analytics";
import UserManagement from "pages/user-management";
import HotelSettings from "pages/hotel-settings";
import Settings from "pages/settings";
import RoomTypes from "pages/room-types";
import NotFound from "pages/NotFound";
import SurveyPage from "pages/survey";
import SurveysManagement from "pages/surveys";
import SurveyTemplatesPage from "pages/survey-templates";
import ReservationCompletionPage from "pages/reservation-completion";
import HotelLanding from "pages/hotel-landing";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here */}
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/login" element={<Login />} />
          <Route path="/select-hotel" element={<SelectHotel />} />
          <Route path="/survey/:token" element={<SurveyPage />} />
          <Route path="/reservation-completion/:token" element={<ReservationCompletionPage />} />
          <Route path="/hotel/:code" element={<HotelLanding />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/financial-management" element={
            <ProtectedRoute>
              <FinancialManagement />
            </ProtectedRoute>
          } />
          <Route path="/reservations" element={
            <ProtectedRoute>
              <Reservations />
            </ProtectedRoute>
          } />
          <Route path="/room-management" element={
            <ProtectedRoute>
              <RoomManagement />
            </ProtectedRoute>
          } />
          <Route path="/reports-and-analytics" element={
            <ProtectedRoute>
              <ReportsAndAnalytics />
            </ProtectedRoute>
          } />
          <Route path="/user-management" element={
            <ProtectedRoute>
              <UserManagement />
            </ProtectedRoute>
          } />
          <Route path="/hotel-settings" element={
            <ProtectedRoute>
              <HotelSettings />
            </ProtectedRoute>
          } />
          <Route path="/settings" element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          } />
          <Route path="/room-types" element={
            <ProtectedRoute>
              <RoomTypes />
            </ProtectedRoute>
          } />
          <Route path="/surveys" element={
            <ProtectedRoute>
              <SurveysManagement />
            </ProtectedRoute>
          } />
          <Route path="/survey-templates" element={
            <ProtectedRoute>
              <SurveyTemplatesPage />
            </ProtectedRoute>
          } />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;